import { AbstractControl } from '@angular/forms';

import { DateOfBirthConstants } from '../../date-of-birth.constants';

export function yearValidator(control: AbstractControl) {
    return control.get('month').value && control.get('day').value && control.get('year').value &&
        Number(control.get('year').value) < DateOfBirthConstants.MAX_YEAR ?
        { invalidYear: true } : null;
}
